import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { getContasReceberKpisTypes } from '../types/getContasReceberKpis';

async function ContasReceberGraficos(params): Promise<getContasReceberKpisTypes> {
  const api = await getApi();
  const { data } = await api.get<getContasReceberKpisTypes>('/contas_receber/graficos/', {params});
  return data;
}

type QueryFnType = typeof ContasReceberGraficos;

function useContasReceberGraficos(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-contas-receber-graficos', params],
    queryFn: () =>  ContasReceberGraficos(params),
  });
}

export { useContasReceberGraficos };
